import { render, staticRenderFns } from "./LogReport.vue?vue&type=template&id=4070792e"
import script from "./LogReport.vue?vue&type=script&lang=js"
export * from "./LogReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports